import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import {
  Reel_Title,
  ReelSub_Title,
} from '../../../../../utils/ES/Modals/PostModals';

const ModalPostReel = () => {
  return (
    <>
      <ModalVideo
        id="reel-post"
        dataText={Reel_Title}
        videoSrc="https://player.vimeo.com/video/703929599?h=d0cf555318&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_REEL_POST"
        subText={ReelSub_Title}
      />
    </>
  );
};

export default ModalPostReel;
